export enum CampaignObjectivesEnum {
  ALL_CAMPAIGN_OBJECTIVES = 'ALL_CAMPAIGN_OBJECTIVES',
  REACH = 'REACH',
  LINK_CLICKS = 'LINK_CLICKS',
  VIDEO_VIEWS = 'VIDEO_VIEWS',
  CONVERSIONS = 'CONVERSIONS',
  APP_INSTALLS = 'APP_INSTALLS',
  POST_ENGAGEMENT = 'POST_ENGAGEMENT',
  PAGE_LIKES = 'PAGE_LIKES',
  LEAD_GENERATION = 'LEAD_GENERATION'
}
